import { createSelector } from 'reselect';

export const filteredGiftsByStopListSelector = createSelector(
  [state => state.sailplay.gifts.list, state => state.restaurant.stopList],
  (gifts, stopList) =>
    gifts.filter(gift => {
      const giftId = gift.item.id;

      return stopList.find(stopListItem => giftId !== stopListItem.good);
    }),
);
